// Object-variable signature helpers for incremental parser cache validity.
// Parser cache is invalidated when object variable content changes.
import type { LuisArrayVariables, LuisObjectVariables } from '../../types'
import { createStableHash } from '../../incremental/hash'

// Build deterministic signature from object-variable map.
export function createObjectVariablesSignature(
  objectVariables: LuisObjectVariables,
  arrayVariables: LuisArrayVariables = {},
): string {
  const objectNames = Object.keys(objectVariables).sort()
  const arrayNames = Object.keys(arrayVariables).sort()
  const serialized: string[] = []

  // Serialize each object variable and its keys in deterministic order.
  for (const objectName of objectNames) {
    const objectValue = objectVariables[objectName]
    const keys = Object.keys(objectValue).sort()
    const entries: string[] = []
    // Serialize each key/value pair for current object variable.
    for (const key of keys) {
      entries.push(`${key}:${objectValue[key].trim()}`)
    }

    serialized.push(`${objectName}=>${entries.join('|')}`)
  }

  // Include array values because object expansion can resolve array references.
  for (const arrayName of arrayNames) {
    serialized.push(`${arrayName}=>${arrayVariables[arrayName].map((item) => item.trim()).join('|')}`)
  }

  // Return hashed object-variable signature string.
  return createStableHash(serialized.join('\u001f'))
}
